<div class="tw-min-h-[60vh] tw-max-w-2xl tw-mx-auto tw-px-4 tw-py-8">
  <!-- Loading states -->
  <div *ngIf="step === 'checking' || step === 'processing'" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-20">
    <div class="tw-w-12 tw-h-12 tw-border-4 tw-border-blue-200 tw-border-t-blue-600 tw-rounded-full tw-animate-spin tw-mb-6"></div>
    <p class="tw-text-lg tw-font-semibold tw-text-slate-800">
      {{ step === 'checking' ? 'Verificando tu información...' : 'Analizando tu CV...' }}
    </p>
    <p *ngIf="step === 'processing'" class="tw-text-sm tw-text-slate-500 tw-mt-2">
      Nuestra IA está buscando las vacantes más compatibles con tu perfil.
    </p>
    <div class="tw-w-full tw-max-w-xs tw-h-1.5 tw-bg-slate-100 tw-rounded-full tw-mt-6 tw-overflow-hidden">
      <div class="tw-h-full tw-bg-blue-600 tw-rounded-full tw-animate-pulse" style="width:60%"></div>
    </div>
  </div>

  <!-- Phone input step -->
  <div *ngIf="step === 'phone'" class="tw-py-8">
    <div class="tw-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-xl tw-bg-green-100 tw-mb-5">
      <svg class="tw-w-7 tw-h-7" style="color:#16a34a" fill="currentColor" viewBox="0 0 448 512">
        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L1.9 480l117.7-30.9c32.4 17.7 68.9 27 106.2 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.8-9.7-10.2-13.4-10.4-3.5-.2-7.5-.2-11.5-.2-4 0-10.5 1.5-16 7.4-5.5 5.9-21.1 20.6-21.1 49.7 0 29.1 21.1 57.4 24 61.6 2.9 4.2 39.4 60.2 95.8 82 56.4 21.8 56.4 14.5 66.5 13.6 10.2-.9 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-4-10.5-6.7z"/>
      </svg>
    </div>
    <h1 class="tw-text-2xl tw-font-bold tw-text-slate-800 tw-mb-2">Activa WhatsApp</h1>
    <p class="tw-text-sm tw-text-slate-500 tw-mb-6">
      Para enviarte tus matches por WhatsApp, ingresa tu número y confírmalo con un código.
    </p>

    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
      <select [(ngModel)]="selectedDialCode"
              class="tw-py-2.5 tw-px-3 tw-rounded-xl tw-border tw-text-sm tw-bg-slate-50 tw-font-medium tw-text-slate-600 tw-outline-none"
              [style.borderColor]="phoneError ? '#dc2626' : '#e2e8f0'">
        <option *ngFor="let c of countries" [value]="c.dial">{{ c.flag }} +{{ c.display }}</option>
      </select>
      <input type="tel" [(ngModel)]="phoneNumber"
             placeholder="1122334455"
             class="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-text-sm tw-outline-none"
             [style.borderColor]="phoneError ? '#dc2626' : '#e2e8f0'"
             (keyup.enter)="sendOtp()">
    </div>
    <p *ngIf="phoneError" class="tw-text-xs tw-text-red-600 tw-mt-1">{{ phoneError }}</p>

    <button (click)="sendOtp()" [disabled]="sendingOtp"
            class="tw-w-full tw-mt-4 tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
            [style.background]="sendingOtp ? '#94a3b8' : '#25D366'">
      <span *ngIf="!sendingOtp">Enviar código por WhatsApp</span>
      <span *ngIf="sendingOtp">Enviando...</span>
    </button>
    <button (click)="dismissPrompt()" [disabled]="sendingOtp"
            class="tw-w-full tw-mt-3 tw-py-2 tw-text-sm tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer"
            style="color:#94a3b8">
      Tal vez después
    </button>
  </div>

  <!-- CV Upload step -->
  <div *ngIf="step === 'cv'" class="tw-py-8">
      <div class="tw-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-xl tw-mb-5"
           style="background:#fffbeb;color:#d97706">
        <svg class="tw-w-7 tw-h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-800 tw-mb-2">Sube tu CV</h1>
      <p class="tw-text-sm tw-text-slate-500 tw-mb-6">
        Antes de activar GuruMatch necesitas subir tu CV. Aceptamos formato PDF y Word.
      </p>

      <div *ngIf="cvUploadError"
           class="tw-p-3 tw-rounded-xl tw-mb-4 tw-text-sm"
           style="background:#fef2f2;color:#dc2626;border:1px solid #fecaca">
        {{ cvUploadError }}
      </div>

      <input #fileInput type="file" accept=".pdf,.doc,.docx" (change)="onPickCv($event)"
             [disabled]="uploadingCv" class="tw-hidden">
      <button type="button" (click)="onClickUpload()" [disabled]="uploadingCv"
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-py-10 tw-px-4 tw-rounded-xl tw-border-2 tw-border-dashed tw-cursor-pointer tw-transition-colors tw-border-0"
              [style]="uploadingCv ? 'background:#f1f5f9;border-color:#cbd5e1;cursor:not-allowed' : 'background:#f8fafc;border-color:#6366f1'">
        <svg *ngIf="!uploadingCv" class="tw-w-10 tw-h-10 tw-mb-3" style="color:#6366f1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/>
        </svg>
        <div *ngIf="uploadingCv" class="tw-w-10 tw-h-10 tw-mb-3 tw-border-4 tw-border-indigo-200 tw-border-t-indigo-600 tw-rounded-full tw-animate-spin"></div>
        <span *ngIf="!uploadingCv" class="tw-text-sm tw-font-medium" style="color:#6366f1">Seleccionar archivo</span>
        <span *ngIf="uploadingCv" class="tw-text-sm tw-text-slate-400">Subiendo CV...</span>
        <span class="tw-text-xs tw-text-slate-400 tw-mt-1">PDF · DOC · DOCX</span>
      </button>

      <button (click)="goHome()" [disabled]="uploadingCv"
              class="tw-w-full tw-mt-6 tw-py-3 tw-rounded-xl tw-text-sm tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer"
              style="color:#94a3b8">
        Cancelar
      </button>
  </div>

  <!-- OTP verify step -->
  <div *ngIf="step === 'otp'" class="tw-py-8 tw-text-center">
    <div class="tw-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-xl tw-bg-blue-100 tw-mb-5 tw-mx-auto">
      <svg class="tw-w-7 tw-h-7" style="color:#2563eb" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
      </svg>
    </div>
    <h1 class="tw-text-2xl tw-font-bold tw-text-slate-800 tw-mb-2">Código de verificación</h1>
    <p class="tw-text-sm tw-text-slate-500 tw-mb-6">
      Enviamos un código a <span class="tw-font-medium">+{{ fullPhone }}</span>
    </p>

    <input type="text" [(ngModel)]="otpCode" [disabled]="verifyingOtp"
           maxlength="6" inputmode="numeric" autocomplete="one-time-code"
           placeholder="000000"
           class="tw-w-48 tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-text-xl tw-text-center tw-tracking-[8px] tw-font-mono tw-outline-none tw-mx-auto"
           [style.borderColor]="otpError ? '#dc2626' : '#e2e8f0'"
           (keyup.enter)="verifyOtp()">

    <div *ngIf="otpError"
         class="tw-flex tw-items-start tw-gap-2.5 tw-mt-4 tw-p-3 tw-rounded-xl tw-text-sm tw-text-left"
         [ngClass]="otpError.includes('otra cuenta') ?
                    'tw-bg-amber-50 tw-text-amber-800 tw-border tw-border-amber-200' :
                    'tw-bg-red-50 tw-text-red-700 tw-border tw-border-red-200'">
      <span class="tw-text-base tw-flex-shrink-0 tw-leading-5">{{ otpError.includes('otra cuenta') ? '⚠️' : '❌' }}</span>
      <span>{{ otpError }}</span>
    </div>

    <button (click)="verifyOtp()" [disabled]="otpCode.length < 6 || verifyingOtp"
            class="tw-w-full tw-mt-4 tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
            [style.background]="otpCode.length < 6 || verifyingOtp ? '#94a3b8' : '#6366f1'">
      <span *ngIf="!verifyingOtp">Verificar</span>
      <span *ngIf="verifyingOtp">Verificando...</span>
    </button>

    <button (click)="resendOtp()" [disabled]="sendingOtp"
            class="tw-mt-4 tw-text-sm tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer"
            [style.color]="sendingOtp ? '#94a3b8' : '#6366f1'">
      {{ sendingOtp ? 'Enviando...' : 'Reenviar código' }}
    </button>
  </div>

  <!-- Results -->
  <div *ngIf="step === 'results'" class="tw-py-4">
    <div class="tw-bg-gradient-to-br tw-from-indigo-500 tw-to-indigo-700 tw-rounded-2xl tw-p-6 tw-text-center tw-text-white tw-mb-6">
      <svg class="tw-w-10 tw-h-10 tw-mx-auto tw-mb-3" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
      <h2 class="tw-text-xl tw-font-bold tw-text-white">¡Match encontrado!</h2>
      <p class="tw-text-sm tw-text-white/70 tw-mt-1">Encontramos {{ matches.length }} vacantes compatibles con tu perfil.</p>
      <div *ngIf="sent" class="tw-inline-flex tw-items-center tw-gap-1.5 tw-mt-3 tw-px-3 tw-py-1.5 tw-rounded-full" style="background:rgba(255,255,255,.15)">
        <svg class="tw-w-4 tw-h-4" style="color:#4ade80" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
        <span class="tw-text-xs">Enviado a tu WhatsApp</span>
      </div>
    </div>

    <div *ngIf="channel === 'NONE'" class="tw-p-4 tw-rounded-xl tw-mb-4" style="background:#fffbeb;border:1px solid #fde68a">
      <p class="tw-text-sm tw-text-amber-800">Los matches se muestran aquí. Verifica tu WhatsApp para recibirlos directamente.</p>
    </div>

    <!-- Match cards -->
    <div *ngFor="let m of matches" class="tw-bg-white tw-rounded-xl tw-border tw-border-slate-100 tw-p-4 tw-mb-3" style="box-shadow:0 1px 3px rgba(0,0,0,.08)">
      <div class="tw-flex tw-items-start tw-gap-3">
        <div class="tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-sm tw-flex-shrink-0"
             [style.background]="getScoreBg(m.score)"
             [style.color]="getScoreColor(m.score)">
          {{ m.score }}%
        </div>
        <div class="tw-flex-1 tw-min-w-0">
          <p class="tw-font-semibold tw-text-sm tw-text-slate-800">{{ m.titulo }}</p>
          <p *ngIf="m.empresa" class="tw-text-xs" style="color:#6366f1">{{ m.empresa }}</p>
          <p *ngIf="m.ubicacion || m.modalidad" class="tw-text-xs tw-text-slate-400">
            {{ getLocationText(m) }}
          </p>
        </div>
        <button *ngIf="m.urlVacante" (click)="viewJob(m.urlVacante)"
                class="tw-p-2 tw-rounded-lg tw-border-0 tw-bg-transparent tw-cursor-pointer" style="color:#6366f1">
          <svg class="tw-w-5 tw-h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Premium upsell -->
    <div class="tw-bg-indigo-50 tw-rounded-xl tw-border tw-border-indigo-100 tw-p-5 tw-mt-4">
      <p class="tw-font-semibold tw-text-sm tw-text-slate-800 tw-text-center tw-mb-1">¿Quieres recibir vacantes como estas todos los días?</p>
      <p class="tw-text-xs tw-text-slate-500 tw-text-center tw-mb-4">TG Empleos Premium te envía alertas personalizadas por WhatsApp.</p>
      <button (click)="goPlans()"
              class="tw-w-full tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
              style="background:#6366f1">
        Ver planes Premium
      </button>
    </div>

    <button (click)="goHome()" class="tw-w-full tw-mt-4 tw-py-3 tw-rounded-xl tw-text-sm tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer" style="color:#6366f1">
      Ir al inicio
    </button>
  </div>

  <!-- Error -->
  <div *ngIf="step === 'error'" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16">
    <div class="tw-w-16 tw-h-16 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-2xl tw-mb-5"
         style="background:#f1f5f9;color:#64748b">
      {{ errorIcon }}
    </div>
    <h2 class="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-2">{{ errorTitle }}</h2>
    <p class="tw-text-sm tw-text-slate-500 tw-text-center tw-mb-6">{{ errorMsg }}</p>
    <button (click)="goPlans()"
            *ngIf="errorTitle.includes('Ya usaste')"
            class="tw-w-full tw-max-w-xs tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
            style="background:#6366f1">
      Ver planes
    </button>
    <button (click)="goHome()"
            class="tw-mt-3 tw-text-sm tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer"
            style="color:#6366f1">
      Ir al inicio
    </button>
  </div>
</div>
